webpackJsonp([16],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_en_US__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_zh_CN__ = __webpack_require__(30);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
	locale: 'enUS',
	fallbackLocale: 'enUS',
	messages: { enUS: __WEBPACK_IMPORTED_MODULE_2__i18n_en_US__["a" /* default */], zhCN: __WEBPACK_IMPORTED_MODULE_3__i18n_zh_CN__["a" /* default */] }
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		loadingCount: 0,
		msgParam: null,
		user: null,
		appList: [],
		campaignDict: {}
	},
	mutations: {
		loading: function loading(state, val) {
			state.loadingCount = val ? state.loadingCount + 1 : state.loadingCount - 1;
		},
		msgParam: function msgParam(state, val) {
			state.msgParam = val;
		},
		user: function user(state, val) {
			state.user = val;
		},
		appList: function appList(state, val) {
			state.appList = val;
		},
		campaignDict: function campaignDict(state, val) {
			state.campaignDict = val;
		}
	}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(2);



var uiHelper = function uiHelper() {
	var loading = function loading(isShow) {
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('loading', isShow);
	};

	var msgBox = function msgBox(msg, type, endFun, buttons) {
		type = typeof type === 'undefined' ? 'info' : type;
		buttons = typeof buttons === 'undefined' ? [__WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('_page.msgbox.ok')] : buttons;

		var info = { content: msg, type: type, buttonList: buttons, endFun: endFun };

		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('msgParam', info);
	};

	return {
		loading: loading,
		msgbox: msgBox
	};
};

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		if (uiHelper.installed) {
			return;
		}
		uiHelper.installed = true;
		Vue.prototype.uiHelper = uiHelper();
	},

	instance: uiHelper()
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jQuery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_ui_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(1);





var dataHelper = function dataHelper() {
	var dps = __webpack_require__(32).dps;

	var getUrl = function getUrl(url) {
		return dps.base + url + dps.ext;
	};

	var ui = __WEBPACK_IMPORTED_MODULE_1__helper_ui_js__["a" /* default */].instance;

	var trans = function trans(param) {
		ui.loading(true);
		__WEBPACK_IMPORTED_MODULE_0_jQuery___default.a.ajax({
			url: getUrl(param.url),
			dataType: 'json',
			jsonp: 'callback',
			jsonpCallback: 'dwrap',
			data: typeof param.data === 'undefined' ? {} : param.data,
			type: typeof param.method === 'undefined' ? 'GET' : param.method.toUpperCase(),
			success: function success(rs) {
				if (!param.keepLoading) {
					ui.loading(false);
				}
				if (typeof param.originData !== 'undefined' && param.originData) {
					param.success(rs);
				} else {
					if (typeof rs.user !== 'undefined') {
						__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('user', rs.user);
					}
					if (rs.code < 0) {
						ui.msgbox(__WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('_error.warning') + __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('_error.' + rs.data), 'warning', function (idx) {
							rs.code === -100 ? window.location.href = '/' : null;
						});
						return;
					}
					param.success(rs.data);
				}
			},
			error: function error(rs) {
				ui.loading(false);
				if (typeof param.error !== 'undefined') {
					param.error(rs);
				} else {
					ui.msgbox(__WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('_error.systemError'), 'danger');
				}
			},
			complete: function complete() {
				if (param.complete) {
					param.complete();
				}
			}
		});
	};

	return {
		trans: trans,
		getUrl: getUrl };
};

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		if (dataHelper.installed) {
			return;
		}
		dataHelper.installed = true;
		Vue.prototype.dataHelper = dataHelper();
	},

	instance: dataHelper()
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var storageHelper = function storageHelper() {
	var pre = 'adyes.mobi.platform.';

	var storage = function storage(st, key, val, exp) {
		if (typeof key !== 'undefined' && !key) {
			return st.clear();
		}

		key = pre + key;

		if (typeof val === 'undefined') {
			var info = st.getItem(key);
			info = JSON.parse(info);
			if (!info) {
				return false;
			}
			if (info.endTime > 0 && info.endTime < new Date().valueOf()) {
				st.removeItem(key);
				return false;
			}
			return info.data;
		}

		if (!val) {
			return st.removeItem(key);
		}

		info = {};
		info.data = val;
		info.endTime = exp ? new Date().valueOf() + exp * 1000 : 0;
		return st.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
	};

	var local = function local(key, val, exp) {
		if (!window.localStorage) {
			window.alert('您的浏览器不支持本地存储，请升级或更换其他高性能浏览器');
		}
		return storage(window.localStorage, key, val, exp);
	};

	var session = function session(key, val, exp) {
		if (!window.sessionStorage) {
			window.alert('您的浏览器不支持本地存储，请升级或更换其他高性能浏览器');
		}
		return storage(window.sessionStorage, key, val, exp);
	};

	return {
		local: local,
		session: session
	};
};

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		if (storageHelper.installed) {
			return;
		}
		storageHelper.installed = true;
		Vue.prototype.storageHelper = storageHelper();
	},

	instance: storageHelper()
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var strHelper = function strHelper() {
	var trim = function trim(str) {
		return str.replace(/(^\s*)|(\s*$)/g, '');
	};

	var pad = function pad(str, totalWidth, paddingChar, isRightPadded) {
		if (str.length < totalWidth) {
			var paddingString = '';
			for (var i = 1; i <= totalWidth - str.length; i++) {
				paddingString += paddingChar;
			}

			if (isRightPadded) {
				return str + paddingString;
			} else {
				return paddingString + str;
			}
		} else {
			return str;
		}
	};

	var padLeft = function padLeft(str, totalWidth, paddingChar) {
		if (paddingChar !== null) {
			return pad(str, totalWidth, paddingChar, false);
		} else {
			return pad(str, totalWidth, ' ', false);
		}
	};
	var padRight = function padRight(str, totalWidth, paddingChar) {
		if (paddingChar !== null) {
			return pad(str, totalWidth, paddingChar, true);
		} else {
			return pad(str, totalWidth, ' ', true);
		}
	};

	return { trim: trim, pad: pad, padLeft: padLeft, padRight: padRight };
};

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		if (strHelper.installed) {
			return;
		}
		strHelper.installed = true;
		Vue.prototype.strHelper = strHelper();
	},

	instance: strHelper()
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(35);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '*',
		component: function component(resolve) {
			__webpack_require__.e/* require.ensure */(13).then((function () {
				resolve(__webpack_require__(16));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/pwdtoken/:token',
		redirect: function redirect(to) {
			return { name: 'entry-password', params: { token: to.params.token } };
		}
	}, {
		path: '/',
		name: 'app',
		component: function component(resolve) {
			__webpack_require__.e/* require.ensure */(4).then((function () {
				resolve(__webpack_require__(13));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		},

		children: [{ path: 'entry', redirect: { name: 'entry-login' } }, {
			path: 'entry',
			name: 'entry',
			component: function component(resolve) {
				__webpack_require__.e/* require.ensure */(14).then((function () {
					resolve(__webpack_require__(15));
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},

			children: [{
				path: 'login/:lang?',
				name: 'entry-login',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(11).then((function () {
						resolve(__webpack_require__(23));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'register/:lang?',
				name: 'entry-register',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(3).then((function () {
						resolve(__webpack_require__(25));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'password',
				name: 'entry-password',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(10).then((function () {
						resolve(__webpack_require__(24));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}]
		}, { path: 'cp', redirect: { name: 'cp-campaign', params: { app: 'all' } } }, {
			path: 'cp',
			name: 'cp',
			component: function component(resolve) {
				__webpack_require__.e/* require.ensure */(15).then((function () {
					resolve(__webpack_require__(14));
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},

			children: [{
				path: 'campaign/:app',
				name: 'cp-campaign',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(5).then((function () {
						resolve(__webpack_require__(20));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'campaignedit/:id',
				name: 'cp-campaignEdit',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(2).then((function () {
						resolve(__webpack_require__(21));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'ads/:campid',
				name: 'cp-ads',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(8).then((function () {
						resolve(__webpack_require__(19));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'adsedit/campid/:campid/id/:id',
				name: 'cp-adsEdit',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(6).then((function () {
						resolve(__webpack_require__(18));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'finance',
				name: 'cp-finance',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(7).then((function () {
						resolve(__webpack_require__(22));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'account',
				name: 'cp-account',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(1).then((function () {
						resolve(__webpack_require__(3));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'password',
				name: 'cp-password',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(0).then((function () {
						resolve(__webpack_require__(4));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}]
		}, { path: 'pub', redirect: { name: 'pub-publish' } }, {
			path: 'pub',
			name: 'pub',
			component: function component(resolve) {
				__webpack_require__.e/* require.ensure */(12).then((function () {
					resolve(__webpack_require__(17));
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},

			children: [{
				path: 'publish',
				name: 'pub-publish',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(9).then((function () {
						resolve(__webpack_require__(26));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'account',
				name: 'pub-account',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {
						resolve(__webpack_require__(3));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'password',
				name: 'pub-password',
				component: function component(resolve) {
					__webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
						resolve(__webpack_require__(4));
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			}]
		}]
	}]
}));

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	_page: {
		msgbox: {
			ok: 'OK',
			cancel: 'Cancel'
		},

		datePicker: {
			shortcut: {
				today: 'Today',
				yesterday: 'Yesterday',
				week: 'Last 7 days',
				month: 'Last month',
				quarter: 'Last 3 month'
			},
			label: {
				startTime: 'Start time',
				endTime: 'End time',
				year: 'Year',
				month: 'Month',
				weekDay: ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun']
			},
			button: { ok: 'Save' }
		},

		top: {
			logout: 'Sign out'
		},

		login: {
			caption: 'Sign in',
			register: ['Need an account first?', 'Sign up here'],
			email: {
				text: 'Email',
				placeholder: 'please enter your email'
			},
			password: {
				text: 'Password',
				placeholder: 'Please enter your password'
			},
			button: {
				login: 'Sign in',
				forgetPassword: 'Forgot password?'
			}
		},

		register: {
			caption: 'Sign up',
			login: ['Have an account?', 'Click here to login'],
			role: {
				text: 'Role',
				placeholder: 'I am a：',
				items: {
					cp: 'Advertiser',
					pub: 'Publisher'
				}
			},
			username: { text: 'Contact Name', placeholder: 'Contact name' },
			email: { text: 'Email', placeholder: 'Email' },
			company: { text: 'Company', placeholder: 'Company name' },
			website: { text: 'Website', placeholder: 'Web site' },
			password: { text: 'Password', placeholder: 'Password' },
			repassword: { text: 'Confirm Password', placeholder: 'Confirmation password' },
			passwordNotice: 'Use letters or numbers, at least 6 characters',
			howtoknow: { placeholder: 'How did you hear about us?' },
			agree: ['I agree to the', 'Terms and Privacy Policy'],
			button: {
				register: 'sign up'
			},
			message: { registerSuccess: 'Registration success' }
		},

		forgetPassword: {
			caption: 'Forgot Password',
			register: ['Need an account first?', 'Sign up here'],
			email: { text: 'Email', placeholder: 'please enter your email' },
			password: { text: 'Password', placeholder: 'Please enter a new password' },
			repassword: { text: 'Confirm Password', placeholder: 'Confirm password' },
			button: {
				find: 'Submit',
				login: 'Return to login'
			},
			message: {
				sendMailSuccess: 'Email sent successfully, please pay attention to check.',
				changePasswordSuccess: 'Password reset complete.'
			}
		},

		common: {
			account: {
				caption: 'Basic Info',
				input: {
					username: {
						text: 'Full Name', placeholder: 'Please enter your contact name'
					},
					email: {
						text: 'Email', placeholder: 'Email not allowed to modify'
					},
					company: {
						text: 'Company', placeholder: 'Please enter your company name'
					},
					website: {
						text: 'Website', placeholder: 'Please enter your web site'
					},
					mobile: {
						text: 'Contact number', placeholder: 'Please enter your contact number'
					}
				},
				button: {
					save: 'Save'
				},
				message: { saveSuccess: 'Save successfully！' }
			},

			password: {
				caption: '',
				input: {
					theold: {
						text: 'Current Password', placeholder: 'Please enter the current password'
					},
					thenew: {
						text: 'New Password', placeholder: 'Please enter a new password'
					},
					renew: {
						text: 'Confirm Password', placeholder: 'Please enter your new password again'
					}
				},
				button: {
					save: 'Save'
				},
				message: { saveSuccess: 'Password changed！' }
			}
		},
		cp: {
			nav: {
				campaign: 'Campaigns',
				account: 'Account',
				finance: 'Finance',
				accountInfo: 'Basic Info',
				password: 'Password'
			},

			campaign: {
				welcome: ['Welcome to ADYes！', 'Start creating your first ad!', 'Create Campaign'],
				list: {
					bar: {
						createCampaign: 'Create Campaign',
						search: 'Search',
						download: 'Export',
						namePlaceholder: 'Please input the ad name',
						status: 'Choose status'
					},
					title: {
						campaign_name: 'Campaign',
						app_name: 'App',
						os: 'Operating system',
						show_number: 'Impressions',
						click_number: 'Clicks',
						cr: 'CTR',
						install_number: 'Installs',
						ir: 'IR',
						bid: 'CPI',
						spend: 'Cost',
						create_time: 'Create time',
						approval_status: 'Approval Status',
						delivery_status: 'Status',
						day_budget: 'Day Budget',
						operating: 'Operating'
					},
					operate: {
						startup: 'Start', edit: 'Edit', stop: 'Stop'
					}
				},
				dialog: {
					firstStartup: 'First promotion needs to be approved by Adyes to start, all campaigns will be activated after approved. Are you sure to start the promotion?'
				} },

			campaignEdit: {
				basic: {
					caption: ['Basic Info', 'To get started please give your campaign a name and select the application you would like to promote.'],
					input: {
						name: {
							text: 'Campaign Name',
							placeholder: 'Give your campaign a descriptive name'
						},
						os: { text: 'Select App to Promote' },
						app_name: {
							text: 'App name',
							placeholder: 'Please enter your app name'
						},
						package_name: {
							text: 'Application package name',
							placeholder: 'Please enter your application package name'
						},
						app_category: {
							text: 'Select Category',
							placeholder: 'Select the category that best describes your application.'
						}
					} },
				tracking: {
					caption: ['Tracking Method', 'Select what tracking platform you are going to use in order to track installs.'],
					input: {
						method: {
							text: 'Tracking Method'
						}
					}
				},
				targeting: {
					caption: ['Targeting', 'Select your targeting criteria.'],
					input: {
						countries: {
							text: 'Select Countries', placeholder: 'Select where you would like to promote your application.'
						},
						device_type: {
							text: 'Select Device Types', select: { all: 'All Device Types', specific: 'Specific Device Types' }
						},
						os_ver: {
							text: 'Select OS Versions', select: { all: 'All Versions', specific: 'Specific Versions' }
						},
						net_speed: {
							text: 'Connection Speeds', select: { all: 'All Connection Speeds', specific: 'Wife Only' }
						},
						google_facebook: {
							text: 'Do you also need Facebook or Google Ads to promote your product(s)?'
						}
					}
				},
				url: {
					caption: ['Tracking Url', 'Enter your AppsFlyer click URLs. For more help on generating URLs and setting up tracking postbacks.'],
					input: {
						click_url: {
							text: 'Click URL'
						}
					}
				},
				budgets: {
					caption: ['Budgets', 'Select your bid type and define your bids'],
					input: {
						bid_type: {
							text: 'Bid Type'
						},
						bid: {
							text: 'Define your bids', placeholder: 'Please enter your bid'
						},
						day_budget: {
							text: 'Daily Budget Target',
							placeholder: 'Please enter your budget price',
							notice: 'Reminder: raise budget, effective on the day, reduce budget, effective next day'
						}
					}
				},
				save: {
					newCaption: ['Campaign Created', 'Congratulation on your campaign creation!'],
					modifyCaption: ['Ad modify complete'],
					button: {
						ok: 'Finish & Save'
					}
				},
				button: {
					lastStep: 'Return', nextStep: 'Continue'
				},
				message: {
					saveSuccess: 'Ad saved successfully！'
				}
			},

			ads: {
				list: {
					bar: {
						createAds: 'Create Ads',
						search: 'Search',
						namePlaceholder: 'Please input the ad name to searh',
						status: 'Please select status'
					},
					title: {
						name: 'Ads',
						app_name: 'APP',
						type: 'Ad Format',
						show_number: 'Impressions',
						click_number: 'Clicks',
						cr: 'CTR',
						install_number: 'Installs',
						ir: 'IR',
						bid: 'CPI',
						spend: 'Cost',
						create_time: 'Create time',
						status: 'Status',
						operating: 'Operating'
					},
					operate: {
						startup: 'Start', edit: 'Edit', stop: 'Stop', view: 'View'
					}
				},
				message: {
					startup: 'After the advertisement originality is enabled, will not be able to carry on the revision again, decides to start?'
				}
			},

			adsEdit: {
				caption: ['Create Ads', 'Enter your ads creative name and upload material information'],
				input: {
					name: { text: 'Name', placeholder: 'Enter cteative set name' },
					type: {
						text: 'Type'
					},
					size: { text: 'Size', placeholder: 'Select Size' },
					ads: { text: 'Ads file' },
					adsIcon: { text: 'Ads icon' }
				},
				button: {
					add: 'Drop files here to upload',
					addIcon: 'Add to app icon here',
					save: 'Save',
					cancel: 'Cancel'
				},
				message: {
					info: 'Please add the "free download", "Play Now" button in the advertising picture, so as to increase the download of the product.',
					fileRequire: 'Material size specification [ {pic_size} ], supports uploading [ {file_type} ] file type, file size must not exceed [ {file_size} ].',
					saveSuccess: 'Save successfully',
					tip: 'ADyes does not accept any advertising material that contains illegal content such as violence, pornography or drugs or may cause user discomfort. Before uploading, please check that your material is in compliance. For violation material, ADyes has the right to stop putting in at any time.',
					previewCaption: 'Advertising styles preview',
					deleteAttachConfirm: 'Are you sure to do it?'
				}
			},

			finance: {
				caption: 'Account Balance',
				list: {
					title: { date: 'Date', spend: 'Spend', recharge: 'Recharge' }
				}
			} },

		pub: {
			nav: { publish: 'Traffic', account: 'Account', password: 'Password' },
			publish: {
				message: 'No revenue currently. Contact ADyes and get the guide of ADyes SDK integration and start monetizing your apps. Your apps will appear here once you initialize your SDK.'
			}
		}
	},

	_error: {
		systemError: 'Server error. Please try again!',
		warning: 'Mistake:',
		noLogin: 'You have not login, or login session overdue, please login!',
		noInput: 'Not filled!',
		noData: 'The data is empty!',
		paramError: 'Parameter error',
		inputError: 'Your input is incorrect.',
		saveDataFailure: 'Data save failed!',

		passwordError: 'Password error!',
		accountOrPasswordError: 'Account or password error！',

		emailInvalid: 'Email is invalid.',
		emailValidFailed: 'Mail validation failed. Please resend the message',
		oldPasswordError: 'Old password error',
		newPasswordError: 'New password error',

		imageError: 'Image is abnormal,Please upload again',
		fileSizeError: 'The attachment size is not legal',
		fileWHError: 'The accessory size is not legal',
		fileExtensionError: 'The attachment type is not legal',
		removeError: 'Delete failed',
		adsNoAttach: 'Please upload ads file',

		registerDataExists: 'Email already registered.',
		attachPostTypeError: 'Upload file type error.',

		moneyNotEnough: 'Account balance not enough.',
		budgetShortage: 'Budget shortage, please raise the budget again after opening.'
	},

	'List total': 'total',

	'Ads image': 'Image',
	'Ads video': 'Video',
	'Ads native ads': 'Native ads',

	'Status paused': 'Paused',
	'Status active': 'Active',

	'Approval pending': 'Pending',
	'Approval passed': 'Passed',
	'Approval did not pass': 'Did not pass',

	'Option choose one': 'Please choose one',

	'How did you hear about us ?': 'How did you hear about us ?',
	'Friend': 'Friend',
	'Blog/Forum': 'Blog/Forum',
	'Advertising': 'Advertising',
	'Other': 'Other',
	'Yes': 'Yes',
	'No': 'No',

	'Click or Drag and Drop files here upload': 'Click or Drag and Drop files here upload',

	'Africa': 'Africa',
	'Asia': 'Asia',
	'Eastern Europe': 'Eastern Europe',
	'Latin America and the Caribbean': 'Latin America and the Caribbean',
	'North America': 'North America',
	'Oceania (AU, NZ, Pacific Islands)': 'Oceania (AU, NZ, Pacific Islands)',
	'Western Europe': 'Western Europe',
	'Algeria (DZ)': 'Algeria (DZ)',
	'Angola (AO)': 'Angola (AO)',
	'Benin (BJ)': 'Benin (BJ)',
	'Botswana (BW)': 'Botswana (BW)',
	'Burkina Faso (BF)': 'Burkina Faso (BF)',
	'Burundi (BI)': 'Burundi (BI)',
	'Cameroon (CM)': 'Cameroon (CM)',
	'Cape Verde (CV)': 'Cape Verde (CV)',
	'Central African Republic (CF)': 'Central African Republic (CF)',
	'Chad (TD)': 'Chad (TD)',
	'Comoros (KM)': 'Comoros (KM)',
	'Congo (CG)': 'Congo (CG)',
	'Congo, the Democratic Republic of the (CD)': 'Congo, the Democratic Republic of the (CD)',
	'Cote D\' Ivoire (CI)': 'Cote D\' Ivoire (CI)',
	'Djibouti (DJ)': 'Djibouti (DJ)',
	'Egypt (EG)': 'Egypt (EG)',
	'Equatorial Guinea (GQ)': 'Equatorial Guinea (GQ)',
	'Eritrea (ER)': 'Eritrea (ER)',
	'Ethiopia (ET)': 'Ethiopia (ET)',
	'Gabon (GA)': 'Gabon (GA)',
	'Gambia (GM)': 'Gambia (GM)',
	'Ghana (GH)': 'Ghana (GH)',
	'Guinea (GN)': 'Guinea (GN)',
	'Guinea-Bissau (GW)': 'Guinea-Bissau (GW)',
	'Kenya (KE)': 'Kenya (KE)',
	'Lesotho (LS)': 'Lesotho (LS)',
	'Liberia (LR)': 'Liberia (LR)',
	'Libyan Arab Jamahiriya (LY)': 'Libyan Arab Jamahiriya (LY)',
	'Madagascar (MG)': 'Madagascar (MG)',
	'Malawi (MW)': 'Malawi (MW)',
	'Mali (ML)': 'Mali (ML)',
	'Mauritania (MR)': 'Mauritania (MR)',
	'Mauritius (MU)': 'Mauritius (MU)',
	'Mayotte (YT)': 'Mayotte (YT)',
	'Morocco (MA)': 'Morocco (MA)',
	'Mozambique (MZ)': 'Mozambique (MZ)',
	'Namibia (NA)': 'Namibia (NA)',
	'Niger (NE)': 'Niger (NE)',
	'Nigeria (NG)': 'Nigeria (NG)',
	'Reunion (RE)': 'Reunion (RE)',
	'Rwanda (RW)': 'Rwanda (RW)',
	'Saint Helena, Ascension and Tristan da Cunha (SH)': 'Saint Helena, Ascension and Tristan da Cunha (SH)',
	'Sao Tome and Principe (ST)': 'Sao Tome and Principe (ST)',
	'Senegal (SN)': 'Senegal (SN)',
	'Seychelles (SC)': 'Seychelles (SC)',
	'Sierra Leone (SL)': 'Sierra Leone (SL)',
	'Somalia (SO)': 'Somalia (SO)',
	'South Africa (ZA)': 'South Africa (ZA)',
	'South Sudan (SS)': 'South Sudan (SS)',
	'Sudan (SD)': 'Sudan (SD)',
	'Swaziland (SZ)': 'Swaziland (SZ)',
	'Tanzania, United Republic of (TZ)': 'Tanzania, United Republic of (TZ)',
	'Togo (TG)': 'Togo (TG)',
	'Tunisia (TN)': 'Tunisia (TN)',
	'Uganda (UG)': 'Uganda (UG)',
	'Western Sahara (EH)': 'Western Sahara (EH)',
	'Zambia (ZM)': 'Zambia (ZM)',
	'Zimbabwe (ZW)': 'Zimbabwe (ZW)',
	'Afghanistan (AF)': 'Afghanistan (AF)',
	'Armenia (AM)': 'Armenia (AM)',
	'Azerbaijan (AZ)': 'Azerbaijan (AZ)',
	'Bahrain (BH)': 'Bahrain (BH)',
	'Bangladesh (BD)': 'Bangladesh (BD)',
	'Bhutan (BT)': 'Bhutan (BT)',
	'Brunei Darussalam (BN)': 'Brunei Darussalam (BN)',
	'Cambodia (KH)': 'Cambodia (KH)',
	'China (CN)': 'China (CN)',
	'Cyprus (CY)': 'Cyprus (CY)',
	'Georgia (GE)': 'Georgia (GE)',
	'Hong Kong (HK)': 'Hong Kong (HK)',
	'India (IN)': 'India (IN)',
	'Indonesia (ID)': 'Indonesia (ID)',
	'Iran (IR)': 'Iran (IR)',
	'Iraq (IQ)': 'Iraq (IQ)',
	'Israel (IL)': 'Israel (IL)',
	'Japan (JP)': 'Japan (JP)',
	'Jordan (JO)': 'Jordan (JO)',
	'Kazakhstan (KZ)': 'Kazakhstan (KZ)',
	'Korea, Democratic People\'s Republic of (KP)': 'Korea, Democratic People\'s Republic of (KP)',
	'Kuwait (KW)': 'Kuwait (KW)',
	'Kyrgyzstan (KG)': 'Kyrgyzstan (KG)',
	'Lao People\'s Democractic Republic (LA)': 'Lao People\'s Democractic Republic (LA)',
	'Lebanon (LB)': 'Lebanon (LB)',
	'Macao (MO)': 'Macao (MO)',
	'Malaysia (MY)': 'Malaysia (MY)',
	'Maldives (MV)': 'Maldives (MV)',
	'Mongolia (MN)': 'Mongolia (MN)',
	'Myanmar (MM)': 'Myanmar (MM)',
	'Nepal (NP)': 'Nepal (NP)',
	'Oman (OM)': 'Oman (OM)',
	'Pakistan (PK)': 'Pakistan (PK)',
	'Palestinian Territory, Occupied (PS)': 'Palestinian Territory, Occupied (PS)',
	'Philippines (PH)': 'Philippines (PH)',
	'Qatar (QA)': 'Qatar (QA)',
	'Saudi Arabia (SA)': 'Saudi Arabia (SA)',
	'Singapore (SG)': 'Singapore (SG)',
	'Sri Lanka (LK)': 'Sri Lanka (LK)',
	'Syria (SY)': 'Syria (SY)',
	'Taiwan (TW)': 'Taiwan (TW)',
	'Tajikistan (TJ)': 'Tajikistan (TJ)',
	'Thailand (TH)': 'Thailand (TH)',
	'Timor-Leste (TL)': 'Timor-Leste (TL)',
	'Turkey (TR)': 'Turkey (TR)',
	'Turkmenistan (TM)': 'Turkmenistan (TM)',
	'United Arab Emirates (AE)': 'United Arab Emirates (AE)',
	'Uzbekistan (UZ)': 'Uzbekistan (UZ)',
	'Viet Nam (VN)': 'Viet Nam (VN)',
	'Yemen (YE)': 'Yemen (YE)',
	'Korea, Republic of (KR)': 'Korea, Republic of (KR)',
	'Albania (AL)': 'Albania (AL)',
	'Belarus (BY)': 'Belarus (BY)',
	'Bosnia and herzegovina (BA)': 'Bosnia and herzegovina (BA)',
	'Bulgaria (BG)': 'Bulgaria (BG)',
	'Croatia (HR)': 'Croatia (HR)',
	'Czech Republic (CZ)': 'Czech Republic (CZ)',
	'Estonia (EE)': 'Estonia (EE)',
	'Holy See (Vatican City State) (VA)': 'Holy See (Vatican City State) (VA)',
	'Hungary (HU)': 'Hungary (HU)',
	'Latvia (LV)': 'Latvia (LV)',
	'Lithuania (LT)': 'Lithuania (LT)',
	'Macedonia, the Former Yugoslav Republic of (MK)': 'Macedonia, the Former Yugoslav Republic of (MK)',
	'Moldova, Republic of (MD)': 'Moldova, Republic of (MD)',
	'Montenegro (ME)': 'Montenegro (ME)',
	'Poland (PL)': 'Poland (PL)',
	'Romania (RO)': 'Romania (RO)',
	'Russian Federation (RU)': 'Russian Federation (RU)',
	'Serbia (RS)': 'Serbia (RS)',
	'Slovakia (SK)': 'Slovakia (SK)',
	'Slovenia (SI)': 'Slovenia (SI)',
	'Svalbard and Jan Mayen (SJ)': 'Svalbard and Jan Mayen (SJ)',
	'Ukraine (UA)': 'Ukraine (UA)',
	'Aland Islands (AX)': 'Aland Islands (AX)',
	'Anguilla (AI)': 'Anguilla (AI)',
	'Antigua and Barbuda (AG)': 'Antigua and Barbuda (AG)',
	'Argentina (AR)': 'Argentina (AR)',
	'Aruba (AW)': 'Aruba (AW)',
	'Bahamas (BS)': 'Bahamas (BS)',
	'Barbados (BB)': 'Barbados (BB)',
	'Belize (BZ)': 'Belize (BZ)',
	'Bolivia (BO)': 'Bolivia (BO)',
	'Bonaire, Sint Eustatius and Saba (BQ)': 'Bonaire, Sint Eustatius and Saba (BQ)',
	'Brazil (BR)': 'Brazil (BR)',
	'Cayman Islands (KY)': 'Cayman Islands (KY)',
	'Chile (CL)': 'Chile (CL)',
	'Colombia (CO)': 'Colombia (CO)',
	'Costa Rica (CR)': 'Costa Rica (CR)',
	'Cuba (CU)': 'Cuba (CU)',
	'Curacao (CW)': 'Curacao (CW)',
	'Dominica (DM)': 'Dominica (DM)',
	'Dominican Republic (DO)': 'Dominican Republic (DO)',
	'Ecuador (EC)': 'Ecuador (EC)',
	'El Salvador (SV)': 'El Salvador (SV)',
	'Falkland Islands (Malvinas) (FK)': 'Falkland Islands (Malvinas) (FK)',
	'French Guiana (GF)': 'French Guiana (GF)',
	'Grenada (GD)': 'Grenada (GD)',
	'Guadeloupe (GP)': 'Guadeloupe (GP)',
	'Guatemala (GT)': 'Guatemala (GT)',
	'Guyana (GY)': 'Guyana (GY)',
	'Haiti (HT)': 'Haiti (HT)',
	'Honduras (HN)': 'Honduras (HN)',
	'Jamaica (JM)': 'Jamaica (JM)',
	'Martinique (MQ)': 'Martinique (MQ)',
	'Mexico (MX)': 'Mexico (MX)',
	'Montserrat (MS)': 'Montserrat (MS)',
	'Nicaragua (NI)': 'Nicaragua (NI)',
	'Panama (PA)': 'Panama (PA)',
	'Paraguay (PY)': 'Paraguay (PY)',
	'Peru (PE)': 'Peru (PE)',
	'Puerto Rico (PR)': 'Puerto Rico (PR)',
	'Saint Barthélemy (BL)': 'Saint Barthélemy (BL)',
	'Saint Kitts and Nevis (KN)': 'Saint Kitts and Nevis (KN)',
	'Saint Lucia (LC)': 'Saint Lucia (LC)',
	'Saint Martin (French part) (MF)': 'Saint Martin (French part) (MF)',
	'Saint Vincent and the Grenadines (VC)': 'Saint Vincent and the Grenadines (VC)',
	'Sint Maarten (Dutch part) (SX)': 'Sint Maarten (Dutch part) (SX)',
	'Suriname (SR)': 'Suriname (SR)',
	'Trinidad and Tobago (TT)': 'Trinidad and Tobago (TT)',
	'Turks and Caicos Islands (TC)': 'Turks and Caicos Islands (TC)',
	'Uruguay (UY)': 'Uruguay (UY)',
	'Venezuela (VE)': 'Venezuela (VE)',
	'Virgin Islands (VI)': 'Virgin Islands (VI)',
	'Virgin Islands, British (VG)': 'Virgin Islands, British (VG)',
	'Bermuda (BM)': 'Bermuda (BM)',
	'Canada (CA)': 'Canada (CA)',
	'Greenland (GL)': 'Greenland (GL)',
	'Saint Pierre and Miquelon (PM)': 'Saint Pierre and Miquelon (PM)',
	'United States (US)': 'United States (US)',
	'American Samoa (AS)': 'American Samoa (AS)',
	'Australia (AU)': 'Australia (AU)',
	'Cook Islands (CK)': 'Cook Islands (CK)',
	'Fiji (FJ)': 'Fiji (FJ)',
	'French Polynesia (PF)': 'French Polynesia (PF)',
	'Guam (GU)': 'Guam (GU)',
	'Kiribati (KI)': 'Kiribati (KI)',
	'Marshall Islands (MH)': 'Marshall Islands (MH)',
	'Micronesia, Federated States of (FM)': 'Micronesia, Federated States of (FM)',
	'Nauru (NR)': 'Nauru (NR)',
	'New Caledonia (NC)': 'New Caledonia (NC)',
	'New Zealand (NZ)': 'New Zealand (NZ)',
	'Niue (NU)': 'Niue (NU)',
	'Norfolk Island (NF)': 'Norfolk Island (NF)',
	'Northern Mariana Islands (MP)': 'Northern Mariana Islands (MP)',
	'Palau (PW)': 'Palau (PW)',
	'Papua New Guinea (PG)': 'Papua New Guinea (PG)',
	'Pitcairn (PN)': 'Pitcairn (PN)',
	'Samoa (WS)': 'Samoa (WS)',
	'Solomon Islands (SB)': 'Solomon Islands (SB)',
	'Tokelau (TK)': 'Tokelau (TK)',
	'Tonga (TO)': 'Tonga (TO)',
	'Tuvalu (TV)': 'Tuvalu (TV)',
	'Vanuatu (VU)': 'Vanuatu (VU)',
	'Wallis and Futuna (WF)': 'Wallis and Futuna (WF)',
	'Andorra (AD)': 'Andorra (AD)',
	'Austria (AT)': 'Austria (AT)',
	'Belgium (BE)': 'Belgium (BE)',
	'Denmark (DK)': 'Denmark (DK)',
	'Faroe Islands (FO)': 'Faroe Islands (FO)',
	'Finland (FI)': 'Finland (FI)',
	'France (FR)': 'France (FR)',
	'Germany (DE)': 'Germany (DE)',
	'Gibraltar (GI)': 'Gibraltar (GI)',
	'Greece (GR)': 'Greece (GR)',
	'Guernsey (GG)': 'Guernsey (GG)',
	'Iceland (IS)': 'Iceland (IS)',
	'Ireland (IE)': 'Ireland (IE)',
	'Isle of Man (IM)': 'Isle of Man (IM)',
	'Italy (IT)': 'Italy (IT)',
	'Jersey (JE)': 'Jersey (JE)',
	'Liechtenstein (LI)': 'Liechtenstein (LI)',
	'Luxembourg (LU)': 'Luxembourg (LU)',
	'Malta (MT)': 'Malta (MT)',
	'Monaco (MC)': 'Monaco (MC)',
	'Netherlands (NL)': 'Netherlands (NL)',
	'Norway (NO)': 'Norway (NO)',
	'Portugal (PT)': 'Portugal (PT)',
	'San Marino (SM)': 'San Marino (SM)',
	'Spain (ES)': 'Spain (ES)',
	'Sweden (SE)': 'Sweden (SE)',
	'Switzerland (CH)': 'Switzerland (CH)',
	'United Kingdom (GB)': 'United Kingdom (GB)',

	'Books & Reference': 'Books & Reference',
	'Comics': 'Comics',
	'Dating': 'Dating',
	'Education': 'Education',
	'Entertainment(non-gaming)': 'Entertainment(non-gaming)',
	'Finance': 'Finance',
	'Game': 'Game',
	'Health & Fitness': 'Health & Fitness',
	'Jobs': 'Jobs',
	'Lifestyle': 'Lifestyle',
	'Media & Video': 'Media & Video',
	'Music & Audio': 'Music & Audio',
	'News & Magazines': 'News & Magazines',
	'Personalization': 'Personalization',
	'Photography': 'Photography',
	'Productivity': 'Productivity',
	'Shopping': 'Shopping',
	'Social': 'Social',
	'Sports(non-gaming)': 'Sports(non-gaming)',
	'Tools': 'Tools',
	'Transportation': 'Transportation',
	'Travel & Local': 'Travel & Local',
	'Weather': 'Weather',

	'iPod': 'iPod',
	'iPhone': 'iPhone',
	'Tablet': 'Tablet',
	'Phone': 'Phone',

	'iOS': 'iOS',
	'Android': 'Android'
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	_page: {
		msgbox: {
			ok: '确定',
			cancel: '取消'
		},

		datePicker: {
			shortcut: {
				today: '今天',
				yesterday: '昨日',
				week: '7天内',
				month: '上个月',
				quarter: '3个月内'
			},
			label: {
				startTime: '开始时间',
				endTime: '结束时间',
				year: '年',
				month: '月',
				weekDay: ['一', '二', '三', '四', '五', '六', '日']
			},
			button: { ok: '确定' }
		},

		top: {
			logout: '退出登录'
		},

		login: {
			caption: '用户登录',
			register: ['还没有账户？点击', '注册'],
			email: {
				text: '邮箱',
				placeholder: '请输入邮箱'
			},
			password: {
				text: '密码',
				placeholder: '请输入密码'
			},
			button: {
				login: '登录',
				forgetPassword: '忘记密码？'
			}
		},

		register: {
			caption: '注册',
			login: ['已有账户？点击', '登录'],
			role: {
				text: '角色',
				placeholder: '我是：',
				items: {
					cp: '广告主',
					pub: '流量主'
				}
			},
			username: { text: '联系人姓名', placeholder: '联系人姓名' },
			email: { text: '邮箱', placeholder: '邮箱' },
			company: { text: '公司名称', placeholder: '公司名称' },
			website: { text: '网站', placeholder: '网站' },
			password: { text: '密码', placeholder: '密码' },
			repassword: { text: '确认密码', placeholder: '确认密码' },
			passwordNotice: '使用字母或者数字，最少6个字符',
			howtoknow: { placeholder: '你是怎么知道我们的？' },
			agree: ['我同意', '《条款与隐私政策》'],
			button: {
				register: '立即注册'
			},
			message: { registerSuccess: '注册成功' }
		},

		forgetPassword: {
			caption: '找回密码',
			register: ['还没有账户？点击', '注册'],
			email: { text: '邮箱', placeholder: '请输入电子邮件' },
			password: { text: '密码', placeholder: '请输入新密码' },
			repassword: { text: '确认密码', placeholder: '确认密码' },
			button: {
				find: '提交',
				login: '返回登录'
			},
			message: {
				sendMailSuccess: '邮件发送成功，请查收邮件。',
				changePasswordSuccess: '密码修改成功。'
			}
		},

		common: {
			account: {
				caption: '账户信息',
				input: {
					username: {
						text: '联系人姓名', placeholder: '请输入联系人姓名'
					},
					email: {
						text: '邮箱', placeholder: '注册时的邮箱不允许修改。'
					},
					company: {
						text: '公司名称', placeholder: '请输入公司名称'
					},
					website: {
						text: '网站', placeholder: '请输入网站'
					},
					mobile: {
						text: '联系电话', placeholder: '请输入您的联系电话'
					}
				},
				button: {
					save: '保存'
				},
				message: { saveSuccess: '保存成功！' }
			},

			password: {
				caption: '',
				input: {
					theold: {
						text: '当前密码', placeholder: '请输入当前密码'
					},
					thenew: {
						text: '新密码', placeholder: '请输入新密码'
					},
					renew: {
						text: '确认密码', placeholder: '请再次输入新密码'
					}
				},
				button: {
					save: '保存'
				},
				message: { saveSuccess: '密码修改成功！' }
			}
		},
		cp: {
			nav: {
				campaign: '广告管理',
				account: '账户管理',
				finance: '财务报表',
				accountInfo: '账户信息',
				password: '密码修改'
			},

			campaign: {
				welcome: ['欢迎来到ADYes', '开始创建您的第一条广告。', '新建广告'],
				list: {
					bar: {
						createCampaign: '新建广告',
						search: '搜索',
						download: '下载报表',
						namePlaceholder: '请输入要搜索的广告名称',
						status: '状态'
					},
					title: {
						campaign_name: '广告名称',
						app_name: '应用名称',
						os: '操作系统',
						show_number: '展示数',
						click_number: '点击数',
						cr: '点击率',
						install_number: '安装数',
						ir: '安装率',
						bid: '出价',
						spend: '花费',
						create_time: '创建日期',
						approval_status: '审核状态',
						delivery_status: '投放状态',
						day_budget: '日预算',
						operating: '操作'
					},
					operate: {
						startup: '启动', edit: '编辑', stop: '停用'
					}
				},
				dialog: {
					firstStartup: '计划首次启用需要审核，通过后可自动进入投放状态，确定启动吗？'
				} },

			campaignEdit: {
				basic: {
					caption: ['基本信息', '输入您的广告名称，并填写您的应用信息'],
					input: {
						name: {
							text: '广告名称',
							placeholder: '请输入您的广告名称'
						},
						os: { text: '操作系统' },
						app_name: {
							text: '应用名称',
							placeholder: '请输入您的应用名称'
						},
						package_name: {
							text: '应用包名/应用ID',
							placeholder: '请输入您的应用包名/应用ID'
						},
						app_category: {
							text: '应用类别',
							placeholder: '选择一个应用类别'
						}
					} },
				tracking: {
					caption: ['跟踪方法', '选择您要使用的跟踪平台，以便跟踪安装。'],
					input: {
						method: {
							text: '追踪方法'
						}
					}
				},
				targeting: {
					caption: ['定向选择', '选择您的推广定向条件'],
					input: {
						countries: {
							text: '选择国家', placeholder: '选择您要推广的地区'
						},
						device_type: {
							text: '选择设备类型', select: { all: '所有设备类型', specific: '具体设备类型' }
						},
						os_ver: {
							text: '选择操作系统版本', select: { all: '所有版本', specific: '具体版本' }
						},
						net_speed: {
							text: '连接速度', select: { all: '所有连接速度', specific: '仅WIFI' }
						},
						google_facebook: {
							text: '是否需要Facebook或Google投放'
						}
					}
				},
				url: {
					caption: ['跟踪网址', '输入您的AppsFlyer点击和展示跟踪网址。'],
					input: {
						click_url: {
							text: '点击链接'
						}
					}
				},
				budgets: {
					caption: ['推广预算', '选择您的出价类型，并定义预算价格。'],
					input: {
						bid_type: {
							text: '出价类型'
						},
						bid: {
							text: '出价', placeholder: '请输入您的价格（美金）'
						},
						day_budget: {
							text: '日预算',
							placeholder: '输入您的预算金额（美金）',
							notice: '温馨提示：提高预算当日生效，降低预算次日生效'
						}
					}
				},
				save: {
					newCaption: ['广告创建完成', '恭喜您完成广告创建!'],
					modifyCaption: ['广告修改完成'],
					button: {
						ok: '完成并保存'
					}
				},
				button: {
					lastStep: '上一步', nextStep: '下一步'
				},
				message: {
					saveSuccess: '广告计划保存成功！'
				}
			},

			ads: {
				list: {
					bar: {
						createAds: '新建广告创意',
						search: '搜索',
						namePlaceholder: '请输入要搜索的广告序列或广告创意名称',
						status: '状态'
					},
					title: {
						name: '广告创意名称',
						app_name: '应用名称',
						type: '广告形式',
						show_number: '展示数',
						click_number: '点击数',
						cr: '点击率',
						install_number: '安装数',
						ir: '安装率',
						bid: '出价',
						spend: '花费',
						create_time: '创建日期',
						status: '投放状态',
						operating: '操作'
					},
					operate: {
						startup: '启动', edit: '编辑', stop: '停用', view: '查看'
					}
				},
				message: {
					startup: '广告创意启用后将不能再进行修改，确定启动吗？'
				}
			},

			adsEdit: {
				caption: ['新建广告创意', '输入您的广告创意名称，并填写素材用信息'],
				input: {
					name: { text: '广告创意名称', placeholder: '请输入您的广告创意名称' },
					type: {
						text: '广告创意类型'
					},
					size: { text: '素材尺寸', placeholder: '请选择一个尺寸' },
					ads: { text: '素材信息' },
					adsIcon: { text: '素材应用图标' }
				},
				button: {
					add: '添加素材',
					addIcon: '添加应用图标',
					save: '保存',
					cancel: '返回'
				},
				message: {
					info: '请在广告图片中添加“免费下载”"Play Now" 等点击按钮，以提升产品的下载量。',
					fileRequire: '素材尺寸规范[ {pic_size} ]，支持上传[ {file_type} ]类型文件，大小不能超过[ {file_size} ]。',
					saveSuccess: '保存成功',
					tip: 'ADyes不接受任何含有暴力、色情、毒品等违法内容或可能引起用户不适的广告素材。上传前请您检查您的素材是否合规。对于违规素材，ADyes有权随时停止投放。',
					previewCaption: '预览广告样式',
					deleteAttachConfirm: '是否确定删除素材？'
				}
			},

			finance: {
				caption: '账户余额',
				list: {
					title: { date: '日期', spend: '支出', recharge: '存入' }
				}
			} },

		pub: {
			nav: { publish: '流量管理', account: '账户信息', password: '密码修改' },
			publish: {
				message: '当前没有收入。联系ADyes获取安装ADyes SDK的指导说明，当SDK初始化之后，您的APP会在此出现。'
			}
		}
	},

	_error: {
		systemError: '服务器出错，请重试！',
		warning: '错误：',
		noInput: '没有填写！',
		noData: '数据为空！',
		noLogin: '您没有登录，或登录信息已过期，请重新登录!',
		paramError: '参数错误！',
		inputError: '输入内容有误！',
		saveDataFailure: '数据保存失败！',

		passwordError: '密码输入错误！',
		accountOrPasswordError: '账户或密码错误！',

		emailInvalid: '邮件地址无效！',
		emailValidFailed: '邮件验证失败，请重新发送邮件！',
		oldPasswordError: '旧密码错误！',
		newPasswordError: '新密码输入错误！',

		imageError: '图片异常，请重新上传！',
		fileSizeError: '附件大小不合法！',
		fileWHError: '附件尺寸不合法！',
		fileExtensionError: '附件类型不合法！',
		removeError: '删除失败！',
		adsNoAttach: '广告素材文件未上传',

		registerDataExists: '邮箱已注册！',
		attachPostTypeError: '附件类型与选择的广告创意类型不一致',

		moneyNotEnough: '账户余额不足',
		budgetShortage: '预算不足，请提高预算后再次开启'
	},

	'List total': '合计',

	'Ads image': '图片广告',
	'Ads video': '视频广告',
	'Ads native ads': '原生广告',

	'Status paused': '暂停',
	'Status active': '投放中',

	'Approval pending': '审核中',
	'Approval passed': '已审核',
	'Approval did not pass': '审核未通过',

	'Option choose one': '请选择',

	'How did you hear about us ?': '您是怎么知道我们的？',
	'Friend': '朋友',
	'Blog/Forum': '博客/论坛',
	'Advertising': '广告',
	'Other': '其他',
	'Yes': '是',
	'No': '否',

	'Click or Drag and Drop files here upload': '点击此处，或者拖动文件到此处进行上传',

	'Africa': '非洲',
	'Asia': '亚洲',
	'Eastern Europe': '东欧洲',
	'Latin America and the Caribbean': '拉丁美洲和加勒比',
	'North America': '北美',
	'Oceania (AU, NZ, Pacific Islands)': '大洋洲',
	'Western Europe': '西欧',
	'Algeria (DZ)': '阿尔及利亚（DZ）',
	'Angola (AO)': '安哥拉（AO）',
	'Benin (BJ)': '贝宁（BJ）',
	'Botswana (BW)': '博茨瓦纳(BW)',
	'Burkina Faso (BF)': '布基纳法索（BF）',
	'Burundi (BI)': '布隆迪（BI）',
	'Cameroon (CM)': '喀麦隆（CM）',
	'Cape Verde (CV)': '佛得角（CV）',
	'Central African Republic (CF)': '中非共和国（CF）',
	'Chad (TD)': '乍得（TD）',
	'Comoros (KM)': '科摩罗（KM）',
	'Congo (CG)': '刚果（CG）',
	'Congo, the Democratic Republic of the (CD)': '刚果民主共和国（CD）',
	'Cote D\' Ivoire (CI)': '科特迪瓦（CI）',
	'Djibouti (DJ)': '吉布提（DJ）',
	'Egypt (EG)': '埃及（EG）',
	'Equatorial Guinea (GQ)': '赤道几内亚(GQ)',
	'Eritrea (ER)': '厄立特里亚(ER)',
	'Ethiopia (ET)': '埃塞俄比亚（ET）',
	'Gabon (GA)': '加蓬（GA）',
	'Gambia (GM)': '冈比亚（GM）',
	'Ghana (GH)': '加纳（GH）',
	'Guinea (GN)': '几内亚（GN）',
	'Guinea-Bissau (GW)': '几内亚比绍（GW）',
	'Kenya (KE)': '肯尼亚（KE）',
	'Lesotho (LS)': '莱索托（LS）',
	'Liberia (LR)': '利比里亚（LR）',
	'Libyan Arab Jamahiriya (LY)': '阿拉伯利比亚民众国（LY）',
	'Madagascar (MG)': '马达加斯加(MG)',
	'Malawi (MW)': '马拉维（MW）',
	'Mali (ML)': '马里（ML）',
	'Mauritania (MR)': '毛里塔尼亚(MR)',
	'Mauritius (MU)': '毛里求斯（MU）',
	'Mayotte (YT)': '马约特（YT）',
	'Morocco (MA)': '摩洛哥（MA）',
	'Mozambique (MZ)': '莫桑比克（MZ）',
	'Namibia (NA)': '纳米比亚（NA）',
	'Niger (NE)': '尼日尔(NE)',
	'Nigeria (NG)': '尼日利亚（NG）',
	'Reunion (RE)': '团聚（RE）',
	'Rwanda (RW)': '卢旺达（RW）',
	'Saint Helena, Ascension and Tristan da Cunha (SH)': '圣赫勒拿，阿森松和特里斯坦达库尼亚（SH）',
	'Sao Tome and Principe (ST)': '圣多美和普林西比（ST）',
	'Senegal (SN)': '塞内加尔（SN）',
	'Seychelles (SC)': '塞舌尔（SC）',
	'Sierra Leone (SL)': '塞拉利昂（SL）',
	'Somalia (SO)': '索马里（SO）',
	'South Africa (ZA)': '南非（ZA）',
	'South Sudan (SS)': '南苏丹（SS）',
	'Sudan (SD)': '苏丹（SD）',
	'Swaziland (SZ)': '斯威士兰（SZ）',
	'Tanzania, United Republic of (TZ)': '坦桑尼亚联合共和国（TZ）',
	'Togo (TG)': '多哥（TG）',
	'Tunisia (TN)': '突尼斯（TN）',
	'Uganda (UG)': '乌干达(UG)',
	'Western Sahara (EH)': '西撒哈拉（EH）',
	'Zambia (ZM)': '赞比亚（ZM）',
	'Zimbabwe (ZW)': '津巴布韦（ZW）',
	'Afghanistan (AF)': '阿富汗(AF)',
	'Armenia (AM)': '亚美尼亚(AM)',
	'Azerbaijan (AZ)': '阿塞拜疆（AZ）',
	'Bahrain (BH)': '巴林（BH）',
	'Bangladesh (BD)': '孟加拉国(BD)',
	'Bhutan (BT)': '不丹（BT）',
	'Brunei Darussalam (BN)': '文莱达鲁萨兰国(BN)',
	'Cambodia (KH)': '柬埔寨（KH）',
	'China (CN)': '中国（CN）',
	'Cyprus (CY)': '塞浦路斯（CY）',
	'Georgia (GE)': '格鲁吉亚（GE）',
	'Hong Kong (HK)': '香港（HK）',
	'India (IN)': '印度（IN）',
	'Indonesia (ID)': '印度尼西亚(ID)',
	'Iran (IR)': '伊朗（IR）',
	'Iraq (IQ)': '伊拉克（IQ）',
	'Israel (IL)': '以色列（IL）',
	'Japan (JP)': '日本（JP）',
	'Jordan (JO)': '约旦（JO）',
	'Kazakhstan (KZ)': '哈萨克斯坦(KZ)',
	'Korea, Democratic People\'s Republic of (KP)': '韩国，朝鲜民主主义人民共和国（KP）',
	'Kuwait (KW)': '科威特（KW）',
	'Kyrgyzstan (KG)': '吉尔吉斯斯坦(KG)',
	'Lao People\'s Democractic Republic (LA)': '老挝人民民主共和国(LA)',
	'Lebanon (LB)': '黎巴嫩（LB）',
	'Macao (MO)': '澳门（MO）',
	'Malaysia (MY)': '马来西亚（MY）',
	'Maldives (MV)': '马尔代夫（MV）',
	'Mongolia (MN)': '蒙古（MN）',
	'Myanmar (MM)': '缅甸(MM)',
	'Nepal (NP)': '尼泊尔(NP)',
	'Oman (OM)': '阿曼（OM）',
	'Pakistan (PK)': '巴基斯坦(PK)',
	'Palestinian Territory, Occupied (PS)': '巴勒斯坦领土，占领区（PS）',
	'Philippines (PH)': '菲律宾（PH）',
	'Qatar (QA)': '卡塔尔（QA）',
	'Saudi Arabia (SA)': '沙特阿拉伯（SA）',
	'Singapore (SG)': '新加坡（SG）',
	'Sri Lanka (LK)': '斯里兰卡（LK）',
	'Syria (SY)': '叙利亚（SY）',
	'Taiwan (TW)': '台湾（TW）',
	'Tajikistan (TJ)': '塔吉克斯坦（TJ）',
	'Thailand (TH)': '泰国（TH）',
	'Timor-Leste (TL)': '东帝汶(TL)',
	'Turkey (TR)': '土耳其（TR）',
	'Turkmenistan (TM)': '土库曼斯坦(TM)',
	'United Arab Emirates (AE)': '阿拉伯联合酋长国（AE）',
	'Uzbekistan (UZ)': '乌兹别克斯坦(UZ)',
	'Viet Nam (VN)': '越南（VN）',
	'Yemen (YE)': '也门（YE）',
	'Korea, Republic of (KR)': '韩国（KR）',
	'Albania (AL)': '阿尔巴尼亚（AL）',
	'Belarus (BY)': '白俄罗斯（BY）',
	'Bosnia and herzegovina (BA)': '波斯尼亚和黑塞哥维那(BA)',
	'Bulgaria (BG)': '保加利亚（BG）',
	'Croatia (HR)': '克罗地亚（HR）',
	'Czech Republic (CZ)': '捷克共和国（CZ）',
	'Estonia (EE)': '爱沙尼亚（EE）',
	'Holy See (Vatican City State) (VA)': '教廷（梵蒂冈城）（VA）',
	'Hungary (HU)': '匈牙利（HU）',
	'Latvia (LV)': '拉脱维亚（LV）',
	'Lithuania (LT)': '立陶宛（LT）',
	'Macedonia, the Former Yugoslav Republic of (MK)': '马其顿前南斯拉夫的（MK）',
	'Moldova, Republic of (MD)': '摩尔多瓦共和国（MD）',
	'Montenegro (ME)': '黑山（ME）',
	'Poland (PL)': '波兰（PL）',
	'Romania (RO)': '罗马尼亚（RO）',
	'Russian Federation (RU)': '俄罗斯联邦（RU）',
	'Serbia (RS)': '塞尔维亚（RS）',
	'Slovakia (SK)': '斯洛伐克（SK）',
	'Slovenia (SI)': '斯洛文尼亚（SI）',
	'Svalbard and Jan Mayen (SJ)': '斯瓦尔巴德和扬・梅嫩（SJ）',
	'Ukraine (UA)': '乌克兰（UA）',
	'Aland Islands (AX)': '爱尔兰群岛（AX）',
	'Anguilla (AI)': '安圭拉（AI）',
	'Antigua and Barbuda (AG)': '安提瓜和巴布达（AG）',
	'Argentina (AR)': '阿根廷（AR）',
	'Aruba (AW)': '阿鲁巴（AW）',
	'Bahamas (BS)': '巴哈马（BS）',
	'Barbados (BB)': '巴巴多斯（BB）',
	'Belize (BZ)': '伯利兹（BZ）',
	'Bolivia (BO)': '玻利维亚（BO）',
	'Bonaire, Sint Eustatius and Saba (BQ)': '博内尔岛，Sint Eustatius和Saba（BQ）',
	'Brazil (BR)': '巴西（BR）',
	'Cayman Islands (KY)': '开曼群岛（KY）',
	'Chile (CL)': '智利（CL）',
	'Colombia (CO)': '哥伦比亚（CO）',
	'Costa Rica (CR)': '哥斯达黎加(CR)',
	'Cuba (CU)': '古巴（CU）',
	'Curacao (CW)': '库拉索（CW）',
	'Dominica (DM)': '多米尼克（DM）',
	'Dominican Republic (DO)': '多米尼加共和国（DO）',
	'Ecuador (EC)': '厄瓜多尔（EC）',
	'El Salvador (SV)': '萨尔瓦多（SV）',
	'Falkland Islands (Malvinas) (FK)': '福克兰群岛（马尔维纳斯）（FK）',
	'French Guiana (GF)': '法属圭亚那（GF）',
	'Grenada (GD)': '格林纳达（GD）',
	'Guadeloupe (GP)': '瓜德罗普（GP）',
	'Guatemala (GT)': '危地马拉（GT）',
	'Guyana (GY)': '圭亚那（GY）',
	'Haiti (HT)': '海地（HT）',
	'Honduras (HN)': '洪都拉斯（HN）',
	'Jamaica (JM)': '牙买加（JM）',
	'Martinique (MQ)': '马提尼克（MQ）',
	'Mexico (MX)': '墨西哥（MX）',
	'Montserrat (MS)': '蒙特塞拉特（MS）',
	'Nicaragua (NI)': '尼加拉瓜（NI）',
	'Panama (PA)': '巴拿马（PA）',
	'Paraguay (PY)': '巴拉圭（PY）',
	'Peru (PE)': '秘鲁（PE）',
	'Puerto Rico (PR)': '波多黎各（PR）',
	'Saint Barthélemy (BL)': '圣巴特雷米（BL）',
	'Saint Kitts and Nevis (KN)': '圣基茨和尼维斯（KN）',
	'Saint Lucia (LC)': '圣卢西亚（LC）',
	'Saint Martin (French part) (MF)': '圣马丁（法语部分）（MF）',
	'Saint Vincent and the Grenadines (VC)': '圣文森特和格林纳丁斯（VC）',
	'Sint Maarten (Dutch part) (SX)': '圣马丁（荷兰语部分）（SX）',
	'Suriname (SR)': '苏里南（SR）',
	'Trinidad and Tobago (TT)': '特立尼达和多巴哥（TT）',
	'Turks and Caicos Islands (TC)': '特克斯和凯科斯群岛（TC）',
	'Uruguay (UY)': '乌拉圭（UY）',
	'Venezuela (VE)': '委内瑞拉（VE）',
	'Virgin Islands (VI)': '维尔京群岛（VI）',
	'Virgin Islands, British (VG)': '维京群岛，英国（VG）',
	'Bermuda (BM)': '百慕大（BM）',
	'Canada (CA)': '加拿大（CA）',
	'Greenland (GL)': '格陵兰（GL）',
	'Saint Pierre and Miquelon (PM)': '圣皮埃尔和密克隆（PM）',
	'United States (US)': '美国（US）',
	'American Samoa (AS)': '美属萨摩亚（AS）',
	'Australia (AU)': '澳大利亚（AU）',
	'Cook Islands (CK)': '库克群岛（CK）',
	'Fiji (FJ)': '斐济（FJ）',
	'French Polynesia (PF)': '法属波利尼西亚（PF）',
	'Guam (GU)': '关岛（GU）',
	'Kiribati (KI)': '基里巴斯（KI）',
	'Marshall Islands (MH)': '马绍尔群岛（MH）',
	'Micronesia, Federated States of (FM)': '密克罗尼西亚联邦（FM）',
	'Nauru (NR)': '瑙鲁（NR）',
	'New Caledonia (NC)': '新喀里多尼亚（NC）',
	'New Zealand (NZ)': '新西兰（NZ）',
	'Niue (NU)': '纽埃（NU）',
	'Norfolk Island (NF)': '诺福克岛（NF）',
	'Northern Mariana Islands (MP)': '北马里亚纳群岛（MP）',
	'Palau (PW)': '帕劳（PW）',
	'Papua New Guinea (PG)': '巴布亚新几内亚（PG）',
	'Pitcairn (PN)': '皮特凯恩（PN）',
	'Samoa (WS)': '萨摩亚（WS）',
	'Solomon Islands (SB)': '所罗门群岛（SB）',
	'Tokelau (TK)': '托克劳（TK）',
	'Tonga (TO)': '汤加（TO）',
	'Tuvalu (TV)': '图瓦卢（TV）',
	'Vanuatu (VU)': '瓦努阿图（VU）',
	'Wallis and Futuna (WF)': '瓦利斯和富图纳（WF）',
	'Andorra (AD)': '安道尔（AD）',
	'Austria (AT)': '奥地利（AT）',
	'Belgium (BE)': '比利时（BE）',
	'Denmark (DK)': '丹麦（DK）',
	'Faroe Islands (FO)': '法罗群岛(FO)',
	'Finland (FI)': '芬兰（FI）',
	'France (FR)': '法国（FR）',
	'Germany (DE)': '德国（DE）',
	'Gibraltar (GI)': '直布罗陀（GI）',
	'Greece (GR)': '希腊（GR）',
	'Guernsey (GG)': '根西（GG）',
	'Iceland (IS)': '冰岛（IS）',
	'Ireland (IE)': '爱尔兰（IE）',
	'Isle of Man (IM)': '马恩岛（IM）',
	'Italy (IT)': '意大利（IT）',
	'Jersey (JE)': '泽西（JE）',
	'Liechtenstein (LI)': '列支敦士登(LI)',
	'Luxembourg (LU)': '卢森堡（LU）',
	'Malta (MT)': '马耳他（MT）',
	'Monaco (MC)': '摩纳哥（MC）',
	'Netherlands (NL)': '荷兰（NL）',
	'Norway (NO)': '挪威（NO）',
	'Portugal (PT)': '葡萄牙（PT）',
	'San Marino (SM)': '圣马力诺（SM）',
	'Spain (ES)': '西班牙（ES）',
	'Sweden (SE)': '瑞典（SE）',
	'Switzerland (CH)': '瑞士（CH）',
	'United Kingdom (GB)': '英国（GB）',

	'Books & Reference': '图书与参考',
	'Comics': '漫画',
	'Dating': '约会',
	'Education': '教育',
	'Entertainment(non-gaming)': '娱乐（非游戏）',
	'Finance': '金融',
	'Game': '游戏',
	'Health & Fitness': '健康与健身',
	'Jobs': '工作',
	'Lifestyle': '生活方式',
	'Media & Video': '媒体与视频',
	'Music & Audio': '音乐与音频',
	'News & Magazines': '新闻杂志',
	'Personalization': '个性化',
	'Photography': '摄影',
	'Productivity': '生产率',
	'Shopping': '购物',
	'Social': '社会',
	'Sports(non-gaming)': '体育（非游戏）',
	'Tools': '工具',
	'Transportation': '运输',
	'Travel & Local': '旅游与地区',
	'Weather': '天气',

	'iPod': '苹果音乐播放器',
	'iPhone': '苹果手机',
	'Tablet': '平板电脑',
	'Phone': '手机',

	'iOS': 'iOS版本',
	'Android': 'Android版本'
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_data_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_ui_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_string_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_storage_js__ = __webpack_require__(7);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__helper_data_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__helper_ui_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__helper_string_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__helper_storage_js__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
	i18n: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */]
});

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = {
	dps: {
		base: '/data/',
		ext: ''
	}
};

/***/ })
],[31]);


// WEBPACK FOOTER //
// static/js/app.94ee852f6dea98a8e6ba.js